import { FC } from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Site } from "../../../redux/slices/sitesSlice";

interface SitesMultiSelectProps {
  id: string;
  label: string;
  options: Site[];
  value: Site[];
  loading?: boolean;
  onChange: (value: Site[]) => void;
}

export const getSiteLabel = (site: Site) => `${site.Code} - ${site.Libelle}`;

/** Retrouve les objets Site à partir des codes affectés ; un code absent de Sage reste sélectionnable. */
export const resolveSites = (codes: string[], sites: Site[]): Site[] =>
  codes.map(
    (code) =>
      sites.find((site) => site.Code === code) || { Code: code, Libelle: code }
  );

/** Sélection multiple de sites Sage (vente ou expédition), affichée sous forme de puces. */
const SitesMultiSelect: FC<SitesMultiSelectProps> = ({
  id,
  label,
  options,
  value,
  loading,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Autocomplete
      id={id}
      multiple
      disableCloseOnSelect
      options={options}
      value={value}
      loading={loading}
      onChange={(_, newValue) => onChange(newValue)}
      getOptionLabel={getSiteLabel}
      isOptionEqualToValue={(option, selected) => option.Code === selected.Code}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option.Code}
            label={option.Code}
            size="small"
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} label={label} margin="normal" />
      )}
      noOptionsText={t("administration.representantSites.noOption")}
    />
  );
};

export default SitesMultiSelect;
